import React from 'react';
import ReportFrame from '../ReportFrame';

export default class LineItemFeeRevenueByIndustry extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ReportType']}
          reportName='Revenue Metrics - Line Item Fee Revenue by Industry'
          reportParams={reportParams}
          id='lineitemfeerevenuebyindustry'
          name='lineitemfeerevenuebyindustry'
          title='Line Item Fee Revenue by Industry'
        />
      </div>
    );
  }
}
